var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { datadogLogs } from '@datadog/browser-logs';
import EventEmitter from 'eventemitter3';
import obfuscateLog from '../utils/obfuscate-log';
import { getStore } from '../state';
import { selectModalSessionId } from '../state/slices/slice-link-params';
import { createFireAnalyticsEventTypeFn } from '../tracking/analytics';
import { getTimeSinceOpen } from '../tracking/datadog';
var eventEmitter = new EventEmitter();
var logToDatadog = function (event, payload, state) {
    var internalEventPayload = payload;
    var eventName = event;
    if (event === 'link_api_response') {
        eventName += " (".concat(internalEventPayload.response.responseType, ")");
        internalEventPayload = obfuscateLog(payload);
    }
    else if (event === 'ui') {
        var _a = payload.data, value = _a.value, eventWithoutValue = __rest(_a, ["value"]);
        eventName += " (".concat(eventWithoutValue.eventId, ")");
        internalEventPayload = __assign(__assign({}, eventWithoutValue), { value: value ? '*' : undefined });
    }
    else if (event === 'link_api_request') {
        eventName += " (".concat(internalEventPayload.params.uri.split('/v1')[1], ")");
        internalEventPayload = obfuscateLog(payload);
    }
    else if (event === 'impression') {
        var src = state.segment.currentSource;
        eventName += " (".concat(src, ")");
        internalEventPayload.currentSource = src;
    }
    else if (event === 'state') {
        eventName += " (".concat(internalEventPayload.action, ")");
    }
    datadogLogs.logger.info(eventName, {
        internalEventPayload: internalEventPayload,
        timeSinceOpen: getTimeSinceOpen(),
    });
};
var eventQueue = {
    on: function (event, callback) { return eventEmitter.on(event, callback); },
    emit: function (event, payload) {
        var payloadState = payload.state;
        var fallbackState = getStore().getState();
        var state = __assign(__assign({}, fallbackState), payloadState);
        var fireAnalyticsEvent = createFireAnalyticsEventTypeFn(state);
        var fireClientEvent = (window.clientEmitters &&
            window.clientEmitters[selectModalSessionId(state)]) ||
            (function () { });
        logToDatadog(event, payload, state);
        eventEmitter.emit(event, __assign({ state: state, fireClientEvent: fireClientEvent, fireAnalyticsEvent: fireAnalyticsEvent }, payload));
    },
};
Object.freeze(eventQueue);
export default eventQueue;
